import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

// TODO: This component previously used createDivision, updateDivision, selectDivision, selectSeason
// which have been removed. It needs a rewrite to work with the new category-based structure.
// For now, the update logic is commented out since divisions no longer exist.
import ClubbieButton from "../ClubbieButton/ClubbieButton";
import ClubbieInput from "../ClubbieInput/ClubbieInput";
import ClubbieModal from "../Modal/ClubbieModal";

/**
 * UpdateTournamentTeams - JSX component with Tailwind CSS
 * Modal for updating number of teams in tournament
 *
 * NOTE: Previously created/updated divisions. Divisions have been removed.
 * This component needs a rewrite to work with categories.
 *
 * @param {boolean} isOpen - Modal visibility state
 * @param {function} onClose - Callback to close modal
 */
const UpdateTournamentTeams = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  const selectedCategory = useSelector(
    (state) => state.tournament.selectedCategory
  );
  const [isLoading, setIsLoading] = useState(false);
  const [numberOfTeams, setNumberOfTeams] = useState(
    selectedCategory?.numberOfTeams?.toString() || ""
  );

  const handleUpdateNoOfTeams = async () => {
    try {
      if (!numberOfTeams) {
        toast.error("Please select a valid number");
        return;
      }

      setIsLoading(true);

      // TODO: Rewrite this to use the new category-based structure.
      // Previously this created/updated divisions which no longer exist.
      // Need to update the category's numberOfTeams instead.
      toast.error("Update not yet implemented for new category structure");
    } catch (error) {
      toast.error(error.message || "Failed to update number of teams");
    } finally {
      setIsLoading(false);
    }
  };

  const handleNumberOfTeamsChange = (e) => {
    const value = e.target.value;
    // Only allow positive numbers
    if (value === "" || (parseInt(value) > 0 && /^\d+$/.test(value))) {
      setNumberOfTeams(value);
    }
  };

  return (
    <ClubbieModal
      isOpen={isOpen}
      toggle={onClose}
      title="Update Number of Teams"
    >
      <div className="flex flex-col gap-4 p-6">
        <ClubbieInput
          type="number"
          placeholder="Edit Number of Teams"
          value={numberOfTeams}
          onChange={handleNumberOfTeamsChange}
          min="1"
          className="w-full"
        />

        <ClubbieButton
          className="w-full"
          onClick={handleUpdateNoOfTeams}
          disabled={isLoading || !numberOfTeams}
          isLoading={isLoading}
        >
          Update
        </ClubbieButton>
      </div>
    </ClubbieModal>
  );
};

export default UpdateTournamentTeams;
